var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0757 13.1612V35.0581C35.0757 37.0971 33.4228 38.75 31.3839 38.75H8.61644C6.57745 38.75 4.92456 37.0971 4.92456 35.0581V4.94187C4.92448 2.90289 6.57737 1.25 8.61644 1.25H23.8655L35.0757 13.1612Z",
    fill: "#E5252A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0757 13.1612H26.3267C24.9674 13.1612 23.8655 12.0592 23.8655 10.6999V1.25L35.0757 13.1612Z",
    fill: "#ED676A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7922 27.5848V30.0798H11.0208V22.7296H13.9531C14.5155 22.7296 15.0131 22.833 15.4458 23.0397C15.8784 23.2464 16.2125 23.542 16.4504 23.9242C16.686 24.3064 16.8061 24.7391 16.8061 25.2245C16.8061 25.9408 16.549 26.5129 16.0346 26.9431C15.5226 27.3709 14.8183 27.5848 13.9218 27.5848H12.7922ZM12.7922 26.2172H13.9531C14.2968 26.2172 14.5588 26.1331 14.739 25.96C14.9193 25.7894 15.0083 25.5466 15.0083 25.2341C15.0083 24.8904 14.9145 24.6164 14.7294 24.4097C14.5443 24.2054 14.292 24.102 13.9723 24.0972H12.7922V26.2172Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7488 30.0796V22.7295H20.1163C20.7653 22.7295 21.3493 22.8761 21.8685 23.1718C22.3853 23.465 22.7914 23.8808 23.0823 24.4193C23.3732 24.9553 23.5197 25.5561 23.5221 26.2219V26.5608C23.5221 27.2338 23.3803 27.8371 23.0967 28.3707C22.8131 28.9043 22.4117 29.3202 21.8949 29.623C21.3781 29.9235 20.8012 30.0749 20.1667 30.0797H17.7488V30.0796ZM19.5203 24.0971V28.7168H20.1356C20.6451 28.7168 21.0345 28.5366 21.3061 28.1736C21.5801 27.8131 21.7171 27.2747 21.7171 26.5608V26.2436C21.7171 25.5321 21.5801 24.9985 21.3061 24.6379C21.0345 24.2774 20.6379 24.0971 20.1164 24.0971H19.5203Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0622 27.1522H26.2043V30.0798H24.4329V22.7296H29.3482V24.0973H26.2043V25.7894H29.0622V27.1522Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.929ed675ff7aff05e807f40ef7a65a91.svg";
export { ForwardRef as ReactComponent };